function isValidURL(url: string) {
  const urlPattern = /["//<>#%{}|\\^~[\]`]/;
  return !urlPattern.test(url);
}

export default isValidURL;
